import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { db } from "../../../../firebase";
import OverallAnalytics from "./OverallAnalytics";
import HighFailCombinations from "./HighFailCombinations";
import CustomSidebar from "../../../Sidebar/Sidebar";
import PrerequisiteEffectiveness from "./PrerequisiteEffectiveness";
import TimeConflicts from "./TimeConflicts";
import SectionDetails from "./SectionDetails";

const CourseAnalyticsPage = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const courseNumber = decodeURIComponent(pathSegments[pathSegments.length - 1]);
  
  const [analyticsData, setAnalyticsData] = useState(null);
  const [activeChartIndex, setActiveChartIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("Overview");

  useEffect(() => {
    const fetchAnalyticsData = async () => {
      if (courseNumber) {
        try {
          const courseRef = db.collection("courses").doc(courseNumber);
          const docSnapshot = await courseRef.get();

          if (docSnapshot.exists) {
            setAnalyticsData(docSnapshot.data());
          } else {
            console.log("No such document!");
          }
        } catch (error) {
          console.error("Error fetching Firestore data:", error);
        }
      }
    };

    fetchAnalyticsData();
  }, [courseNumber]);

  if (!analyticsData) return <div>Loading...</div>;

  return (
    <div className="flex">
        <CustomSidebar adjustment="Analytics" />
        <div className="w-[90vw] ml-20 mt-6 mb-3 px-4 py-4 border border-gray-300 rounded shadow-md">
            {/* Header Section with inline back arrow */}
            <div className="flex justify-between items-center mb-1">
            <h2 className="text-2xl font-bold text-gray-800 flex items-center">
                <Link to="/scheduling-analytics" className="mr-2 text-gray-600 hover:text-gray-800">
                &larr;
                </Link>
                {analyticsData?.courseNumber} - {analyticsData?.courseName} Analytics
            </h2>
            </div>

            {/* Tabs Navigation */}
            <div className="flex border-b mb-3">
            {["Overview", "High-Fail Combinations", "Time Conflicts", "Section Details"].map((tab) => (
                <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 mr-1 -mb-px border-b-2 font-medium text-sm focus:outline-none transition-colors ${
                    activeTab === tab
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-600 hover:text-blue-600 hover:border-blue-500"
                }`}
                >
                {tab}
                </button>
            ))}
            </div>

            {/* Tab Content */}
            {activeTab === "Overview" && (
            <OverallAnalytics
                analyticsData={analyticsData}
                activeChartIndex={activeChartIndex}
                setActiveChartIndex={setActiveChartIndex}
            />
            )}
            {activeTab === "High-Fail Combinations" && (
            <HighFailCombinations courseNumber={analyticsData?.courseNumber} />
            )}
            {activeTab === "Time Conflicts" && <TimeConflicts />}
            {activeTab === "Section Details" && <SectionDetails />}
        </div>
    </div>
  );
};

export default CourseAnalyticsPage;
